import {VerifyOTPAndSaveTokenCookiesResponse} from '@/services/fortress/Fortress';
import axios from '@/utils/axios';
import {Product} from '@/types/product';

interface AuthenticateDashboardUserProps {
  verifySession: VerifyOTPAndSaveTokenCookiesResponse;
  product?: Product;
  firstName?: string;
  lastName?: string;
  organizationName?: string;
}

const authenticationUpdaters = {
  authenticateDashboardUser: async (props: AuthenticateDashboardUserProps) =>
    axios.post(`/authentication/dashboard_user/sign_in`, {
      token: props.verifySession.token,
      client: 'internal',
      refreshToken: props.verifySession.refreshToken,
      refreshTokenExpirationS: props.verifySession.refreshTokenExpirationS,
      isNew: props.verifySession.isNew,
      firstName: props.firstName,
      lastName: props.lastName,
      organizationName: props.organizationName,
      signupType: props.product, // TODO: add backend support for productType or authType since this is used for both signup and login
    }),
};

export default authenticationUpdaters;
